module.exports = __webpack_public_path__ + "img/201712-2.5c29f755.jpeg";